import { lazy, Suspense } from "react";
import ProfilePage from "../pages/OrganizerPage";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


const Home = lazy(() => import("../pages/home/Home"));
const About = lazy(() => import("../pages/about/About"));
const Pricing = lazy(() => import("../pages/Pricing.jsx"));
const Contact = lazy(() => import("../pages/contact/Contact"));
const List = lazy(() => import("../pages/eventlist/eventlist"));
const MoviesList = lazy(() => import("../pages/movieslist/Movieslist"));
const venueList = lazy(() => import("../pages/venuelist/Venuelist"));
const Termsandcondition = lazy(() => import("../pages/termsandcondition.jsx"));
const Privacypolicy = lazy(() => import("../pages/privacypolicy.jsx"));
const Imprint = lazy(() => import("../pages/Imprint.jsx"));
const Ticket = lazy(() => import("../component/TicketPage.jsx"));
const BookingAttendees = lazy(() =>
  import("../pages/attendees/BookingAttendeesPage.jsx")
);
const SelfFillAttendee = lazy(() =>
  import("../pages/attendees/SelfFillAttendeePage.jsx")
);
const Scanner = lazy(() => import("../pages/Scanner.jsx"));
const paymentProcessing = lazy(() => import("../pages/PaymentProcessing.jsx"));
const AdminLogin = lazy(() =>
  import("../component/Admin/AuthAdmin/AdminLogin")
);
const ForgetPassword = lazy(() =>
  import("../component/register/ForgetPassword")
);
const ForgetPasswordOrg = lazy(() =>
  import("../component/register/ForgetPasswordOrg")
);
const RestPassword = lazy(() => import("../component/register/RestPassword"));
const RestPasswordOrg = lazy(() =>
  import("../component/register/RestPasswordOrg")
);
const VerifyEmailOrganizer = lazy(() =>
  import("../component/register/VerifyOrgEmail")
);
const Navbar = lazy(() => import("../component/navbar/Navbar"));
const Footer = lazy(() => import("../component/footer/Footer"));
const Register = lazy(() => import("../component/register/Register"));

const VerifyEmail = lazy(() => import("../component/register/VerifyEmail"));
const RegisterOrganizer = lazy(() =>
  import("../component/register/RegisterOrganizer")
);
const BuilderPage = lazy(() => import("../pages/TemplateBuilderPage"));
const Login = lazy(() => import("../component/login/Login"));
const GoogleSuccess = lazy(() => import("../component/AuthSuccess.jsx"));
const Organizer = lazy(() => import("../component/organizer/Organizer"));
const Favorites = lazy(() => import("../component/favorites/Favorites"));
const DashboardMenu = lazy(() =>
  import("../component/dashboard/DashBoardMenu")
);
const ScannerActivation = lazy(()=> import("../component/ScannerActivationPage.jsx"));

const EventSelection = lazy(() =>
  import("../component/eventselection/Eventselectionn")
);
const EventTicket = lazy(() => import("../component/eventticket/Eventticket"));
const ConfirmBooking = lazy(() =>
  import("../component/confirmbooking/Confirmbooking")
);
const ConfirmTicket = lazy(() =>
  import("../component/confirmticket/Confirmticket")
);
const MovieSelection = lazy(() =>
  import("../component/movieselection/Movieselection")
);
const MoviesTicket = lazy(() =>
  import("../component/moviestickets/Moviesticket")
);
const ConfirmMovieTicket = lazy(() =>
  import("../component/confirmmovieticket/ConfirmMovieTicket")
);
const ScannerLogin = lazy(() => import("../pages/scanner/login.jsx"));
const defaultPacks = lazy(()=> import ("../pages/DefaultPacksPage"))
// const CreateCampaignPage = lazy(()=> import ("../pages/OrganizerCampain/CreateCampaignPage.jsx"))
// const CampaignDetailPage = lazy(() => import("../pages/OrganizerCampain/ViewCampaignPage.jsx"));
// const CampaignListPage = lazy(() => import( "../pages/OrganizerCampain/CampaignListPage.jsx"));
// const CampaignEditPage = lazy(() => import("../pages/OrganizerCampain/CampaignEditPage.jsx"));
// const SponsorsLogin = lazy(() => import("../component/sponsors/SponsorsLogin.jsx"));

const renderRoute = (Component) => (
  <Suspense
    fallback={
      <div className="flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
      </div>
    }
  >
    <Component />
  </Suspense>
);

// Wraps a component with GoogleReCaptchaProvider — use only on form/auth pages
const WithRecaptcha = ({ children }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_SITEKEY}
    scriptProps={{ async: true, defer: true, appendTo: "head" }}
  >
    {children}
  </GoogleReCaptchaProvider>
);

const renderRouteWithRecaptcha = (Component) => (
  <WithRecaptcha>
    <Suspense
      fallback={
        <div className="flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
          <span className="sr-only">Loading...</span>
          <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
        </div>
      }
    >
      <Component />
    </Suspense>
  </WithRecaptcha>
);

const navigationRoutes = [
  { name: "Home", path: "/", element: renderRoute(Home) },
  {
    name: "Scanner-Login",
    path: "/scanner-login",
    element: renderRoute(ScannerLogin),
  },
  {
    name: "Scanner-Acivation",
    path: "/scanner-activate",
    element: renderRoute(ScannerActivation),
  },
  //   {
  //  name: "TemplateBuilderPage",
  //     path: "/builder-page",
  //     element: renderRoute(BuilderPage),
  //   },
  {
    name: "EventsList",
    path: "/eventslist",
    element: renderRoute(Navbar) && renderRoute(List),
  },
  {
    name: "payment",
    path: "/confirmpayment/:bookingID/:type",
    element: renderRoute(paymentProcessing),
  },
  {
    name: "TicketPage",
    path: "/ticket/:id",
    element: renderRoute(Ticket),
  },
  {
    name: "BookingAttendees",
    path: "/attendees/booking/:bookingId",
    element: renderRoute(BookingAttendees),
  },
  {
    name: "SelfFillAttendee",
    path: "/attendee/:token",
    element: renderRoute(SelfFillAttendee),
  },
  {
    name: "SelfFillAttendeeAlias",
    path: "/attendees/self-fill/:token",
    element: renderRoute(SelfFillAttendee),
  },
  {
    name: "VerifyEmail",
    path: "/verify-email/:verificationToken",
    element: renderRoute(VerifyEmail),
  },
  // {
  //   name: "Scanner",
  //   path: "/scanner",
  //   element: renderRoute(Scanner),
  // },
  {
    name: "VerifyEmailOrganizer",
    path: "/verify-email-org/:verificationToken",
    element: renderRoute(VerifyEmailOrganizer),
  },
  { name: "MoviesList", path: "/movieslist", element: renderRoute(MoviesList) },
  { name: "VenueList", path: "/venuelist", element: renderRoute(venueList) },
  {
    name: "EventSelection",
    path: "/eventselection/:eventName/:eventId",
    element: renderRouteWithRecaptcha(EventSelection),
  },
  {
    name: "Organizer Page",
    path: "/organizer/:name/:id",
    element: renderRoute(ProfilePage),
  },
  {
    name: "Auth-Success",
    path: "/auth-success",
    element: renderRoute(GoogleSuccess),
  },
  {
    name: "EventTicket",
    path: "/eventticket/:eventName/:eventId",
    element: renderRoute(EventTicket),
  },
  {
    name: "MovieTicket",
    path: "/moviesticket/:movieName/:movieId",
    element: renderRoute(MoviesTicket),
  },
  {
    name: "MovieSelction",
    path: "/movieselection/:movieName/:movieId",
    element: renderRoute(MovieSelection),
  },
  {
    name: "ConfirmEventTicket",
    path: "/confirmticket/:eventName/:eventId",
    element: renderRouteWithRecaptcha(ConfirmTicket),
  },
  {
    name: "ConfirmMovieTicket",
    path: "/confirmmovieticket/:movieName/:movieId",
    element: renderRoute(ConfirmMovieTicket),
  },
  {
    name: "Booking",
    path: "/booking/:type/:id",
    element: renderRoute(ConfirmBooking),
  },
  { name: "About", path: "/about", element: renderRoute(About) },
  { name: "imprint", path: "/imprint", element: renderRoute(Imprint) },
  { name: "Pricing", path: "/pricing", element: renderRoute(Pricing) },
  {
    name: "Register",
    path: "/register",
    element: renderRouteWithRecaptcha(Register),
  },
  {
    name: "Contact",
    path: "/contact",
    element: renderRouteWithRecaptcha(Contact),
  },
  { name: "Login", path: "/login", element: renderRouteWithRecaptcha(Login) },
  { name: "Favorites", path: "/favorites", element: renderRoute(Favorites) },
  {
    name: "Termsandcondition",
    path: "/termsandcondition",
    element: renderRoute(Termsandcondition),
  },
  {
    name: "Privacypolicy",
    path: "/privacypolicy",
    element: renderRoute(Privacypolicy),
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    element: renderRoute(DashboardMenu),
  },
  {
    name: "ForgetPassword",
    path: "/forget-password",
    element: renderRouteWithRecaptcha(ForgetPassword),
  },
  {
    name: "ForgetPasswordOrg",
    path: "/forget-password-organizer",
    element: renderRouteWithRecaptcha(ForgetPasswordOrg),
  },
  {
    name: "RestPassword",
    path: "/reset-password/:password_reset_token",
    element: renderRoute(RestPassword),
  },
  {
    name: "RestPasswordOrg",
    path: "/reset-password-organizer/:password_reset_token",
    element: renderRoute(RestPasswordOrg),
  },
  {
    name: "ConfirmBooking",
    path: "/confirmbooking",
    element: renderRoute(ConfirmBooking),
  },
  {
    name: "RegisterOrganizer",
    path: "/registerOrganizer",
    element: renderRouteWithRecaptcha(RegisterOrganizer),
  },
  {
    name: "OrganizerLogin",
    path: "/organizerLogin",
    element: renderRouteWithRecaptcha(Organizer),
  },

  // { path: "/CreateCampaign", element: renderRoute(CreateCampaignPage) },
  // { path: "Campaign/View", element: renderRoute(CampaignDetailPage) },
  // { path: "Campaign/edit", element: renderRoute(CampaignEditPage) },
  // { path: "CampaignList", element: renderRoute(CampaignListPage) },

  {
    name: "AdminLogin",
    path: "/adminLogin",
    element: renderRouteWithRecaptcha(AdminLogin),
  },
  // { name: "sponsorsLogin", path: "/sponsorsLogin", element: renderRoute(SponsorsLogin) },
];

export default navigationRoutes;
